import styles from "./StatisticsReservationDialog.module.scss";
import { IStatisticDetailedItemViewModel } from "../models/statisticDetailedItemViewModel";
import { dateUtility } from "../../../common/infrastructure/utilities/dateUtility";
import { StatisticsDialogKeyValueItem } from "./StatisticsDialogKeyValueItem";
import { MessageStatus } from "../../../common/enums";

const MessageStatusLabels: Record<MessageStatus, string> = {
  [MessageStatus.Pending]: "Чакащ",
  [MessageStatus.Sent]: "Изпратен",
  [MessageStatus.Failed]: "Неуспешен",
  [MessageStatus.Cancelled]: "Отказан",
};

interface IStatisticsEmailDialogProps {
  item: IStatisticDetailedItemViewModel;
}

export const StatisticsEmailDialog = ({ item }: IStatisticsEmailDialogProps) => {
  const statusLabel =
    item.messageStatusCode !== undefined
      ? MessageStatusLabels[item.messageStatusCode as MessageStatus] ?? "-"
      : "-";

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <div className={styles.root_header_left}>
          <h5>{item.userName}</h5>
          <p>
            Дата: <span>{dateUtility.formatDateTime(item.dateTime)}</span>
          </p>
        </div>
      </div>

      <div className={styles.root_content}>
        <StatisticsDialogKeyValueItem
          name={"ПОЛУЧАТЕЛ"}
          value={item.receiverContact ?? "-"}
        />
        <StatisticsDialogKeyValueItem
          name={"ТЕМА"}
          value={item.messageText ?? "-"}
        />
        <StatisticsDialogKeyValueItem name={"СТАТУС"} value={statusLabel} />
      </div>
    </div>
  );
};
